
import { makeAutoObservable, autorun, runInAction, action, observable, makeObservable, computed } from "mobx"
import {evalCondition, browseObject} from '../common'

export class StateAttrs {
    field = false
    record = false
    readonly = null
    required = null
    invisible = null
    dependencies = []
    inputs = ""
    loading = true
    initialized = false
    states = {}

    get definition(){
        return {'required':this.required,'invisible':this.invisible,'readonly':this.readonly}
    }

    constructor(field, record) {
        makeObservable(this, {
            required: observable,
            invisible:observable,
            readonly:observable,
            set_readonly:action,
            set_invisible:action,
            set_required:action,
            // toogleLoading: action,
            initialized: observable,
            loading:observable,
            dependencies:observable,
            inputs:observable,
            reload: action,
            update_inputs:action,
        })

        this.field = field
        this.states = this.field.states
        this.record = record
        const default_attrs = field.default_state_attrs
        this.invisible = default_attrs.invisible
        this.readonly = this.field.screen.readonly == true ? true:default_attrs.readonly
        this.required = default_attrs.required

        // this.value = browseObject(record._values, field.expression)
        this.loading = false
        this.dependencies = this.get_dependencies()
        // this.update_inputs()


    }

    set_readonly(value){
        this.readonly = value;
    }
    set_invisible(value){
        this.invisible = value;
    }
    set_required(value){
        this.required = value;
    }

    get_dependencies(){
        let dependencies = []
        if(this.states){
            //remove first and last {}
            let expr = this.field.states.substring(1, this.field.states.length-1);
            
            expr.match(/{([^}]+)}/g).forEach(function(field_name){
                //remove first and last {}
                field_name = field_name.substring(1, field_name.length-1);
                
                
                //if the value is part of an expression, just take the root field
                if(field_name.includes('.')){
                    field_name = field_name.split('.')[0]
                }
                // Get the actual field, checking for original_name to support multi_model forms
                let field = this.field_by_name(field_name)
                if(field){
                    field_name = field.name
                
                    if(!dependencies.includes(field_name)){
                        dependencies.push(field_name)
                    }
                }
               
                
            }.bind(this))

            
        }
        
        return dependencies
    }

    create_json_value(){
        let vals = {}
        
        this.dependencies.forEach(function(dep){
            const field =  this.field_by_name(dep)
            if(!field){
                console.log("NO FIELD")
                throw new Error("Check the state_attrs configuration of the field: "+this.field.name)
            }
            const value = field.get_value(this.record)
            vals[dep] = value
            
        }.bind(this))
            


        return JSON.stringify(vals)
    }

    update_inputs(){
       
        this.inputs = this.create_json_value()
    }

    field_by_name(fname){
        // return this.record.screen.fields.find(f => f.name === fname)
        return this.record.screen.get_field_by_any_name(fname)
    }

    

    get_value() {
     if(!this.dependencies.length){
        return this
     }
     else{
         if(this.inputsChanged()){
             return this.reload()
             
         }
         else{
             return this
         }
     }

    }
    inputsChanged(){
        let res = false
        const new_values = this.create_json_value()

        if(new_values !== this.inputs){
            res = true
        }
        

        return res
    }

    get_part_value(part){
        let value
        if(typeof part === 'string' && part.startsWith('{')){
            
            let expr = part.substring(1, part.length-1);
            let fname = ""
            let raw = true
            //if the value is part of an expression, just take the root field
            if(expr.includes('.')){
                fname = expr.split('.')[0]
                // Set raw to false, to get the whole value of the field (not just id)
                raw = false
                
            }
            else{
                fname = expr
            }
            value = this.field_by_name(fname).get_value(this.record, raw)
            // The expr requires to be solved based on value
            if (expr != fname){
                expr = expr.replace(fname+'.','')
                value = browseObject(value, expr)
            }
            

        }
        else{
            value = part
            
        }
        return value;
        
    }

    reload(){
        // this.readonly = !this.readonly;
        let json = JSON.parse(this.states)
        
        for(let attr in json){

            let conditions = json[attr].map(function(condition){
                let p1 = this.get_part_value(condition[0])
                let operator = condition[1]
                let p2 = this.get_part_value(condition[2])
                
                return evalCondition(p1,operator,p2)


            }.bind(this))
            
            this[attr] = conditions.every(function (a) {
                return a === true
            })
            
        }
       
        
        this.update_inputs()
        
        return this

        
        
    }
    
}